import styles from "./main.module.scss";

interface Props {
  children?: React.ReactNode;
}

const Main: React.FC<Props> = ({ children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.formWrapper}>{children}</div>

      <div className={styles.authImg}>
        <div className={styles.authLayoutTextContainer}>
          <p className={styles.authLayoutText}>Process your results</p>
          <p className={styles.authLayoutParagraphText}>
            Manage and track all processed results of any
            <br />
            student, in any required year.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Main;
